(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sr-conversion-system"] && !Shopify.designMode) return;
  try {
    (() => {
 if(window.srConversionRevision)return;
 window.srConversionRevision=true;
 document.addEventListener('change',e=>{
  if(!e.target.matches('[data-sr-vibe]'))return;
  const destination=new URL(e.target.value,window.location.origin);
  new URL(window.location.href).searchParams.forEach((value,name)=>{
   if(name==='sort_by')destination.searchParams.append(name,value);
  });
  window.location.assign(destination.href);
 });
 document.addEventListener('click',e=>{document.querySelectorAll('.sr-deals-disclosure[open],.sr-clean-menu[open]').forEach(d=>{if(!d.contains(e.target))d.open=false;});});
 document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.sr-deals-disclosure[open],.sr-clean-menu[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});});
})();
  } catch(e) { console.error(e); }
})();

})();
